import LegalChat from './legal_chat'

// <docs-assistant> — the floating Documentation Assistant help widget
// (Sprint T10). Extends <legal-chat> wholesale: same single conversation
// state, same traveling chat body, same glass modal, same model dropdown
// and markdown rendering. Adds a fixed launcher chip that opens straight
// into the modal, with a gentle attention pulse that stops permanently
// after the first open (persisted in localStorage). Models are fetched
// lazily on first open (data-lazy-models) so ordinary page loads make no
// extra requests.
const OPENED_STORAGE_KEY = 'thordocs:docs-assistant-opened'

export default class extends LegalChat {
  connectedCallback () {
    super.connectedCallback()

    this.launcher = this.querySelector('[data-chat-part="launcher"]')

    if (!this.launcher) return

    if (this.wasOpenedBefore()) this.launcher.classList.remove('thor-help-pulse')

    this.launcher.addEventListener('click', () => {
      this.launcher.classList.remove('thor-help-pulse')
      this.rememberOpened()
      this.openModal()
    })
  }

  openModal () {
    // Lazily load the model catalog on first open. Previously this set a
    // one-way "requested" latch: if that first fetch failed or was abandoned
    // (the cold Bedrock catalog build can take ~18s), the dropdown was left
    // disabled and NEVER retried until a full page reload recreated the
    // element — the "model selector stuck until you refresh" bug. Now we
    // only latch on SUCCESS; a failed load clears the flag so simply
    // re-opening the assistant retries the fetch.
    if (!this.modelsLoaded && !this.modelsLoading) {
      this.modelsLoading = true

      Promise.resolve(this.loadModels()).then((ok) => {
        this.modelsLoading = false
        this.modelsLoaded = ok === true
      }).catch(() => {
        this.modelsLoading = false
        this.modelsLoaded = false
      })
    }

    super.openModal()
  }

  wasOpenedBefore () {
    try {
      return window.localStorage.getItem(OPENED_STORAGE_KEY) === '1'
    } catch {
      return false
    }
  }

  rememberOpened () {
    try {
      window.localStorage.setItem(OPENED_STORAGE_KEY, '1')
    } catch {
      // Private browsing / storage disabled: the pulse simply returns next visit.
    }
  }
}
